import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { QuestionBase } from './question-base';
import { QuestionControlService } from './question-control.service';
import { ToastService } from '../../services';

@Component({
  selector: 'app-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss'],
  providers: [QuestionControlService]
})
export class DynamicFormComponent implements OnInit, OnChanges, OnDestroy {
  @Input() hideSubmit = false;
  @Input() questions: QuestionBase<any>[] = [];
  @Input() showSpinnerUponSubmitting = true;
  @Input() action: string;
  @Input() textareaTip: string;
  @Output() submit = new EventEmitter<Object>();
  @Output() dataChanged = new EventEmitter<Object>();
  form: FormGroup<any>;
  @Input() formError: any;
  private valueChangesSubscription: Subscription;
  public showSpinner = false;

  constructor(private qcs: QuestionControlService, private toastService: ToastService) {}

  public ngOnInit(): void {}

  public ngOnChanges(changes): void {
    if (this.valueChangesSubscription) {
      this.valueChangesSubscription.unsubscribe();
    }
    this.form = this.qcs.toFormGroup(this.questions, this.action);

    this.valueChangesSubscription = this.form.valueChanges.subscribe((data) => {
      this.dataChanged.emit(data);
    });
  }

  public ngOnDestroy(): void {
    if (this.valueChangesSubscription) {
      this.valueChangesSubscription.unsubscribe();
    }
  }

  public onSubmit(): void {
    this.submit.emit(this.form.value);
    this.form.markAsPristine();
    this.setSpinner(true);
  }

  get submitDisabled(): boolean {
    return !this.form.valid || !this.form.dirty;
  }

  public setSpinner(value): void {
    if (this.showSpinnerUponSubmitting) {
      this.showSpinner = value;
    } else {
      this.showSpinner = false;
    }
  }

  public submitted(err): void {
    if (err) {
      this.toastService.showError('', '', '');
    } else {
      this.toastService.showOk('', '', '');
    }
    this.setSpinner(false);
  }
}
